import {Suspense} from 'react';
import * as cciApi from '@di-shared/api/cci/auth';
import {emitEventLog} from '@di-shared/features/analytics';
import AnalyticPageView from '@di-shared/features/analytics/AnalyticPageView';
import {DEMERIT_EDUCATION_GA_SCREEN} from '@di-shared/features/public-service/demerit-education/demeritEducationGaScreenNames';
import {DEFAULT_CACHE_TIME} from '@di-shared/const';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {getQueryKey} from '@shared/queryKeyMap';
import {useSuspenseQuery} from '@tanstack/react-query';

export interface DemeritEducationReservationStep1CheckProps {
  vin: string;
  onNext(): void;
}

function DemeritEducationReservationStep1Check(props: DemeritEducationReservationStep1CheckProps) {
  return (
    <Suspense>
      <Inner {...props} />
    </Suspense>
  );
}

function Inner({onNext}: DemeritEducationReservationStep1CheckProps) {
  const {t} = useInferableTranslation();

  const {data: meData} = useSuspenseQuery({
    queryKey: [getQueryKey(cciApi.getMe)],
    queryFn: () => cciApi.getMe(),
    ...DEFAULT_CACHE_TIME,
  });

  return (
    <div className="wrap">
      <AnalyticPageView screenName={DEMERIT_EDUCATION_GA_SCREEN.RESERVATION__STEP_1_CHECK} />
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T10241')}</h1>
      </Header>
      <main className="content">
        <section className="section">
          <div className="section_container_header">
            <h2 className="title_small_b">{t('T10250')}</h2>
          </div>
          <div className="reservation_info_wrap">
            <div className="reservation_info_box">
              <span className="title">{t('T10251')}</span>
              <p className="reservation_info_text">{meData.name}</p>
            </div>
            <div className="reservation_info_box">
              <span className="title">{t('T10252')}</span>
              <p className="reservation_info_text">{t('T10253')}</p>
            </div>
            <div className="reservation_info_box">
              <span className="title">{t('T10254')}</span>
              {/* 감경 벌점 -20점은 고정값 */}
              <p className="reservation_info_text">{t('T10056_$score', {score: '-20'})}</p>
            </div>
          </div>
        </section>
        <section className="section section_notice">
          <div className="section_container">
            <strong className="notice_title">{t('T10337')}</strong>
            <ul className="notice_list">
              <li className="notice_item">{t('T10338')}</li>
              <li className="notice_item">{t('T10339')}</li>
              <li className="notice_item">{t('T10340')}</li>
              <li className="notice_item">{t('T10341')}</li>
            </ul>
          </div>
        </section>
      </main>
      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => {
            emitEventLog({
              event: 'public_service_interaction',
              data_action: 'Demerit reduction education',
              data_name: 'Confirm eligible target',
            });
            onNext();
          }}
        >
          {t('T10255')}
        </button>
      </div>
    </div>
  );
}

export default DemeritEducationReservationStep1Check;
